var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM13.6926 7H8.1111V17H10.342V13.8939H13.6926C14.6351 13.8939 15.4219 13.5707 16.0532 12.9242C16.6844 12.2778 17 11.4495 17 10.4394C17 9.40909 16.6887 8.58081 16.0661 7.95455C15.4436 7.31818 14.6524 7 13.6926 7ZM13.7056 11.6212H10.342V9.27273H13.7056C14.0168 9.27273 14.2633 9.37879 14.4449 9.59091C14.6351 9.80303 14.7302 10.0859 14.7302 10.4394C14.7302 10.7929 14.6351 11.0808 14.4449 11.303C14.2633 11.5152 14.0168 11.6212 13.7056 11.6212Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaid);
export default __webpack_public_path__ + "static/media/paid.026de7c4e52971bf878ac9bb72969667.svg";
export { ForwardRef as ReactComponent };